export default "__VITE_ASSET__DeWSa4gZ__"